export default __webpack_public_path__ + "static/media/Maduro-4Closed.6cd43d38.jpg";